<template>
  <div class="contain">
    <!-- 검색 조건 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="$device.mobile ? `top` : `left`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :md="8">
            <el-form-item :label="$t('계정')">
              <el-select
                v-model="searchForm.accountId"
                filterable
                remote
                default-first-option
                @keyup.enter.native="searchFirstPage"
                clearable
                :placeholder="$t('계정ID, 계정명을 입력 하여 검색')"
                :remote-method="accountSearch">
                <el-option
                  v-for="item in accounts"
                  :key="item.accountId"
                  :label="item.accountId + ' - ' + item.accountNm"
                  :value="item.accountId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--					<el-col :md="6">-->
          <!--						<el-form-item :label="$t('리소스')">-->
          <!--							<el-select v-model="searchForm.resourcesCd" filterable remote default-first-option @keyup.enter.native="search" clearable-->
          <!--									:placeholder="$t('리소스 정보를 입력 하여 검색')" :remote-method="resourcesSearch">-->
          <!--								<el-option v-for="item in resources" :key="item.resourcesCd" :label="item.resDesc" :value = "item.resourcesCd"></el-option>-->
          <!--							</el-select>-->
          <!--						</el-form-item>-->
          <!--					</el-col>-->
          <el-col :md="16">
            <el-form-item :label="$t('기간')">
              <el-date-picker
                v-model="sedtm"
                type="datetimerange"
                clearable
                unlink-panels
                :style="{ width: $device.mobile ? `100%` : `360px` }"
                :default-time="['06:00:00', '23:00:00']"
                :start-placeholder="$t('날자 선택')"
                :end-placeholder="$t('날자 선택')"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼-->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('HistorySearch')"
        :size="size"
        @click="searchFirstPage"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight - 48"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @sort-change="handleSortChange">
      <el-table-column
        :label="totalElements.toString()"
        type="index"
        width="55"
        align="center"
        fixed
        label-class-name="data_cnt"
        :index="indexMethod"></el-table-column>
      <el-table-column type="selection" width="45" align="center" :fixed="!$device.mobile"></el-table-column>
      <!-- 정렬은 **서버**가 한다(`sortable="custom"`) — 한 장만 받는 목록에서 `sortable` 은 「이 페이지 안에서만」이라
           사람이 본 순서와 서버가 고른 50건이 서로 다른 말을 한다. 중첩 값을 그리는 두 열(`resources.resDesc`·
           `account.accountNm`)의 점 표기는 화면의 어휘일 뿐이라 [sortAliases] 가 서버 컬럼 이름으로 옮긴다 -->
      <el-table-column
        :label="$t('새션Id')"
        prop="sessionId"
        min-width="150"
        align="center"
        sortable="custom"></el-table-column>
      <el-table-column
        :label="$t('계정')"
        prop="account.accountNm"
        width="150"
        align="center"
        sortable="custom"></el-table-column>
      <el-table-column
        :label="$t('리소스')"
        prop="resources.resDesc"
        min-width="200"
        sortable="custom"></el-table-column>
      <el-table-column
        :label="$t('작업시간')"
        prop="inDtm"
        min-width="150"
        align="center"
        sortable="custom"></el-table-column>
      <el-table-column :label="$t('IP')" prop="inIp" min-width="150" align="center" sortable="custom"></el-table-column>
    </el-table>
    <list-pagination
      :search-form="searchForm"
      :total="totalElements"
      @page-change="handlePageChange"
      @size-change="handleSizeChange"></list-pagination>
  </div>
</template>

<script>
import { initData } from '@/utils/constants'
import mainVueMixin from '@/mixins/mainVueMixin'
import pagedListMixin from '@/mixins/pagedListMixin'
import { withPaging } from '@/utils/pagedList'

export default {
  mixins: [mainVueMixin, pagedListMixin],

  data: function () {
    var data = initData()
    data.url = '/history'
    data.accounts = []
    data.resources = []
    data.searchForm = this.initSearchForm()
    data.sedtm = [new Date(), new Date()]

    return data
  },
  computed: {
    /**
     * 중첩 값을 그리는 두 열의 서버 정렬 축 — 점 표기는 **화면의 어휘**지 서버의 컬럼 이름이 아니다.
     *
     * 별칭이 없으면 서버가 화이트리스트 밖의 낱말을 무시해 **눌러도 아무 일이 없는 머리글**이 된다.
     * 화살표는 켜지므로 화면만 봐서는 알 수 없다.
     */
    sortAliases: function () {
      return {
        'account.accountNm': 'accountNm',
        'resources.resDesc': 'resDesc',
      }
    },
  },
  mounted: function () {
    this.$nextTick(
      function () {
        this.mainVue.currVue = this
      }.bind(this)
    )
  },
  methods: {
    // 검색 조건 초기화 — 페이징·정렬 축은 [withPaging] 이 붙인다(기본 50건·첫 페이지·서버 기본 정렬 `inDtm DESC, seq DESC`)
    initSearchForm: function () {
      return withPaging({
        accountId: null,
        resourcesCd: null,
        sdtm: '',
        edtm: '',
      })
    },
    // 계정 자동 검색
    accountSearch: function (accountNm) {
      this.mainVue.$axios.search(
        '/account/searchByIdOrNm/' + accountNm,
        null,
        function (result) {
          this.accounts = result
        }.bind(this)
      )
    },
    // 리소스 자동 검색
    resourcesSearch: function (resDesc) {
      this.mainVue.$axios.search(
        '/resources/' + resDesc,
        null,
        function (result) {
          this.resources = result
        }.bind(this)
      )
    },
    /**
     * 이 조회의 **전제** — 계정과 기간이 골라져 있는가. 없으면 왜 막혔는지 말하고 거짓이다.
     *
     * 믹스인의 네 진입점이 **상태를 쓰기 전에** 이것을 묻는다(`pagedListMixin.canSearch`). 종전에는
     * 판정이 `search()` 첫 줄에 있어서, 2페이지를 눌러 페이저·행 번호가 이미 옮겨 앉은 **뒤에**
     * 되돌아갔다 — 요청은 안 나가는데 화면은 2페이지라고 말하는 상태가 된다.
     */
    canSearch: function () {
      if (this.searchForm.accountId == null || this.searchForm.accountId.length < 1) {
        this.mainVue.$message({ type: 'success', message: this.$t('계정을 선택 하여 주십시오.') })

        return false
      }

      if (null == this.sedtm || this.sedtm.length < 2) {
        this.mainVue.$message({ type: 'success', message: this.$t('기간을 선택 하여 주십시오.') })

        return false
      }

      return true
    },
    /**
     * 조회 — **전제는 이미 확인됐다**(믹스인 게이트). 현재 페이지·정렬을 유지한다.
     *
     * 이력은 최대 2만 행이라 종전처럼 전량을 받아 `slice` 로 자르면 한 번의 조회가 수 MB 다.
     * 이제 한 장(기본 50건)만 묻고 정렬도 서버가 한다. 조건이 바뀐 조회는 `searchFirstPage` 다.
     */
    search: function () {
      this.searchForm.sdtm = this.sedtm[0]
      this.searchForm.edtm = this.sedtm[1]

      this.mainVue.$axios.search(
        this.url,
        this.searchQuery(),
        function (result) {
          this.applyPage(result)
        }.bind(this)
      )
    },
  },
}
</script>
